import { render, staticRenderFns } from "./roomOweFeeCallableList.vue?vue&type=template&id=2d84f0e7&scoped=true"
import script from "./roomOweFeeCallableList.vue?vue&type=script&lang=js"
export * from "./roomOweFeeCallableList.vue?vue&type=script&lang=js"
import style0 from "./roomOweFeeCallableList.vue?vue&type=style&index=0&id=2d84f0e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84f0e7",
  null
  
)

export default component.exports